module.exports = __webpack_public_path__ + "img/logo-small.7af07f20.png";